import { render, staticRenderFns } from "./TiendaNube.vue?vue&type=template&id=ed950d18&"
import script from "./TiendaNube.vue?vue&type=script&lang=js&"
export * from "./TiendaNube.vue?vue&type=script&lang=js&"
import style0 from "./TiendaNube.vue?vue&type=style&index=0&id=ed950d18&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports